import React from 'react';

const Accounts = () => {
  return <>Accounts</>;
};

export default Accounts;
